import React, { FunctionComponent, useMemo } from 'react'
import { Button, Stack } from 'react-bootstrap'
import { UploadIcon } from '../../../svg/UploadIcon'

interface ReUploadComponentProps {
  setReuploadWarningModal: (flag: boolean) => void
}

export const ReUploadComponent: FunctionComponent<ReUploadComponentProps> = ({
  setReuploadWarningModal,
}) => {
  return (
    <div
      style={{
        border: '1px dashed var(--primary-color)',
        padding: '63px 40px',
        background: 'var(--primary-light-color)',
        minHeight: '150px',
        fontSize: '14px',
        marginBottom: '15px',
        borderRadius: '10px',
      }}
    >
      <Stack
        style={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
        gap={2}
      >
        <UploadIcon color='currentColor' />
        <div>
          <div
            className='file-uploader dragDropTitle'
            style={{ cursor: 'pointer' }}
            onClick={() => setReuploadWarningModal(true)}
          >
            Re-Upload Bank statements
          </div>
        </div>
        <div className='file-uploader-sub'>Supported format: PDF</div>
      </Stack>
    </div>
  )
}
